<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-credit-card"></i>&nbsp;<ng-container i18n>Buy Credit to Subscribe</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-12">
      <mat-form-field2 class="mat-block">
        <mat-select placeholder="Credit Amount" i18n-placeholder formControlName="amount" required>
          <mat-option [value]="300">$300</mat-option>
          <mat-option [value]="250">$250</mat-option>
          <mat-option [value]="50">$50</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
          Amount is required
        </mat-error>
      </mat-form-field2>
    </div>
    <div i18n class="col-sm-12">
      You can choose one option and click on Submit button which will make your subscription successful.
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Submit</ng-container>
  </button>
</div>
